import { Box, Typography, Divider } from "@mui/material";

const HeaderRendicion = ({ data }) => {
  return (
    <Box>
      <Typography variant="h6" fontWeight={600}>
        Planilla N° {data.nro_rendicion}
      </Typography>

      <Typography>
        Chofer: <strong>{data.nombre_apellido}</strong> — Vehículo:{" "}
        <strong>{data.patente}</strong>
      </Typography>

      <Box mt={2}>
        <Typography variant="subtitle2">Información General:</Typography>
        <Typography variant="body2">Fecha: {data.fecha}</Typography>
        <Typography variant="body2">
          Km Inicial: {data.km_inicial} — Km Final: {data.km_final}
        </Typography>
        <Typography variant="body2">
          Diferencia: {data.km_final - data.km_inicial || "-"}
        </Typography>
        <Typography variant="body2">
          Sucursal: {data.nombre_suc}
        </Typography>
      </Box>

      <Divider sx={{ mt: 2 }} />
    </Box>
  );
};

export default HeaderRendicion;
